import { render, staticRenderFns } from "./DialDesign.vue?vue&type=template&id=6c2a4b3a&scoped=true"
import script from "./DialDesign.vue?vue&type=script&lang=js"
export * from "./DialDesign.vue?vue&type=script&lang=js"
import style0 from "./DialDesign.vue?vue&type=style&index=0&id=6c2a4b3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2a4b3a",
  null
  
)

export default component.exports